/**
 * Define constants
 */
export const SET_FROM_HELP = 'SET_FROM_HELP';
export const SET_HELP_ITEMS = 'SET_HELP_ITEMS';
export const SET_HELP_DAMAGED_CART_DATA = 'SET_HELP_DAMAGED_CART_DATA';

/**
  * Action creators
  */
const actions = {
  setFromHelp: (data) => ({ type: SET_FROM_HELP, data }),
  setHelpItems: (data) => ({ type: SET_HELP_ITEMS, data }),
  setHelpDamagedCartData: (data) => ({ type: SET_HELP_DAMAGED_CART_DATA, data }),
};

export const setFromHelp = (fromHelp) => (dispatch) => dispatch(actions.setFromHelp(fromHelp));

export const setHelpItems = (helpItems) => (dispatch) => dispatch(actions.setHelpItems(helpItems));

export const setHelpDamagedCartData = (helpItems) => (dispatch) => dispatch(
  actions.setHelpDamagedCartData(helpItems)
);
